import { render, staticRenderFns } from "./header.vue?vue&type=template&id=30de9f9c&scoped=true"
import script from "./header.vue?vue&type=script&lang=ts"
export * from "./header.vue?vue&type=script&lang=ts"
import style0 from "./header.vue?vue&type=style&index=0&id=30de9f9c&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../.yarn/__virtual__/vue-loader-virtual-bcca2229bc/0/cache/vue-loader-npm-15.11.1-829412283a-509a816d45.zip/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "30de9f9c",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/usr/src/.yarn/cache/vue-hot-reload-api-npm-2.3.4-549ae26337-9befc0b3d6.zip/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('30de9f9c')) {
      api.createRecord('30de9f9c', component.options)
    } else {
      api.reload('30de9f9c', component.options)
    }
    module.hot.accept("./header.vue?vue&type=template&id=30de9f9c&scoped=true", function () {
      api.rerender('30de9f9c', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/layout/header.vue"
export default component.exports